<qaroni-layout-values-list />

<mat-drawer-container
  class="w-full !bg-qaroni-gray"
  autosize
  [hasBackdrop]="hasBackdrop">
  <mat-drawer
    #drawer
    class="!rounded-[28px] p-2.5 !min-w-[250px] !bg-qaroni-gray lg:!transform-none lg:!block"
    [mode]="matDrawermode"
    [opened]="(isSmallScreen$ | async) === false"
    position="start">
    <qaroni-menu class="h-screen" [isMenuOpen]="true" (closeMenu)="close()" />
  </mat-drawer>

  <div class="flex flex-row w-full h-screen">
    <main
      class="w-full pt-7 mx-4 lg:mr-10 flex flex-col px-2 md:px-0 pb-10 relative">
      <div class="w-full">
        <button
          class="outline-none lg:hidden text-st flex gap-2 ml-2 qaroni-exception"
          (click)="drawer.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      @if (progressBar$ | async) {
        <div class="!absolute w-[98%] h-auto top-[42px] left-[10px]">
          <mat-progress-bar
            color="primary"
            class="!rounded-[28px]"
            mode="indeterminate" />
        </div>
      }

      <div
        class="bg-qaroni-initial rounded-[28px] mt-4 overflow-x-hidden overflow-y-auto pt-5 h-full qaroni-scrollbar">
        <router-outlet />
      </div>
    </main>
  </div>
</mat-drawer-container>
